import type { MantineThemeOverride } from '@mantine/core';
import { buildTheme, type ThemeBuilderProps } from '#ui/theme/theme.builder.ts';

export const zalaThemeBuilderProps = {
	fontFamily: {
		heading: 'Mulish',
		body: 'Mulish',
	},
	colors: {
		preset: {
			primary: 'violet',
			secondary: 'pink',
		},
	},
} as ThemeBuilderProps;

export const zalaLandingThemeBuilderProps = {
	fontFamily: {
		heading: 'Mulish',
		body: 'Mulish',
	},
	colors: {
		preset: {
			primary: 'violet',
			secondary: 'pink',
		},
	},
} as ThemeBuilderProps;

export const zalaTheme: MantineThemeOverride = buildTheme(zalaThemeBuilderProps);
